import * as Queue from "./Queue";
import * as QueuesList from "./QueuesList";

export const getQueueName = () => {
	const routeVars = window.location.href
		.replace(`${window.location.origin}/`, "")
		.split("/");
	if (routeVars.length) return routeVars[0];
	else return null;
};

export const getStageQueues = (queueName) => {
	if (queueName === Queue.ASSET || queueName === Queue.ASSET_REVIEW) {
		return QueuesList.ASSET_QUEUE;
	}
};

export const getStageName = (queueName) => {
	if (queueName === Queue.ASSET) return "ASSET";
	else return "ASSET REVIEW";
};
